export const SET_TAB_VALUE = "SET_TAB_VALUE";

export const setValue = (value) => ({
  type: SET_TAB_VALUE,
  payload: value,
});